import { useSelector } from "react-redux";
import { selectAuth } from "../redux/slices/authSlice";
import { usePermission as useRolePermission } from "../hooks/usePermission";

export const usePermission = () => {
    const auth = useSelector(selectAuth);
    const isAdmin = auth?.isAdmin || false;
    // `auth.permissions` is only populated at login and the staff-detail
    // endpoint has no permissions list to refresh it with, so delegate to the
    // live, role-based query instead (hooks/usePermission.ts) — that one
    // reacts immediately once the user's role_id changes.
    const { hasPermission } = useRolePermission();

    const can = (permission: string) => isAdmin || hasPermission(permission);

    return { can };
};
